module.exports = {"pathContext":{"slug":"/conseil"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/conseil.json
// module id = 559
// module chunks = 272027360619931